export enum SuperAdminPriceMode {
  NotSet = "NotSet",
  Client = "Client",
  Supplier = "Supplier",
  Both = "Both",
}
